import { computed } from "@vue/composition-api";
import * as SettingsGetters from "@Broker/@Modules/settings/store/settings-getters";
import { createNamespacedHelpers } from "vuex-composition-helpers";
const {
  useGetters: useSettingsGetters
} = createNamespacedHelpers("SettingsStore");
export default function getFilogixDetails() {
  const {
    GET_FILOGIX_DETAILS
  } = useSettingsGetters([SettingsGetters.GET_FILOGIX_DETAILS]);
  const filogixDetails = computed(() => GET_FILOGIX_DETAILS.value);
  return {
    filogixDetails
  };
}